/**
 * Корневой компонент сайта: общая шапка, запрет браузерного зума и раскладка вокруг маршрутов.
 */
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useBlockBrowserZoom } from "@/shared/hooks";
import { SiteHeader } from "@/widgets/site-header";
import { PageMetadata } from "./PageMetadata";
import { YandexGoogleMetrics } from "./YandexGoogleMetrics";

export const App = () => {
	useBlockBrowserZoom();

	return (
		<div className="flex h-dvh flex-col">
			<PageMetadata />
			<SiteHeader />
			<Outlet />
			<ToastContainer position="bottom-right" />
			<YandexGoogleMetrics />
		</div>
	);
};
